import React, { useCallback,useEffect,useState } from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import { CssBaseline, makeStyles, createMuiTheme, ThemeProvider } from '@material-ui/core';

import MainNavigation from '../components/client/Navigation/MainNavigation';
import MainNavigationNoDocuemnt from '../components/client/Navigation/MainNavigationNoDocument';
import LoadingSpinner from '../shared/UIElements/LoadingSpinner';
import { AuthContext } from '../shared/context/auth-context';
import { Suspense } from 'react';


import './App.css';

const Admin = React.lazy(() => import('../components/admin/Admin'));
const Auth = React.lazy(() => import('../components/client/Auth'));
const Authenticate = React.lazy(() => import('../components/admin/Authenticate'));
const ClientForm = React.lazy(() => import('../pages/Clients/ClientForm'));
const SignupConfirmation = React.lazy(() => import('../pages/Clients/SignupConfirmation'));
const ClientMenu = React.lazy(() => import('../components/client/ClientMenu'));
const Profile = React.lazy(() => import('../components/client/Profile'));
const Documents = React.lazy(() => import('../components/client/Documents'));
const Contract = React.lazy(() => import('../components/client/Contract.js'));
const ReleveClient = React.lazy(() => import('../components/client/ReleveClient'));
const UploadDocument = React.lazy(() => import('../components/client/UploadDocument'));
const DemandRequestVerification = React.lazy(() => import('../components/client/DemandRequestVerification'));
const ForgotPassword = React.lazy(() => import('../components/client/ForgotPassword.js'));
// const PasswordUpdateForm = React.lazy(() => import('../components/client/PasswordUpdateForm.js'));
const PasswordResetForm = React.lazy(() => import('../components/client/PasswordResetForm.js'));



let logoutTimer;

const theme = createMuiTheme({
  palette: {
    primary: {
      // main: "#629e8f",
      main: '#47a942',
      light: "#66baa5"
    },
    secondary: {
      main: "#f83245",
      // main:'#47a942' ,
      // light: "#f832456"
      light:'#47a942'
    },
    background: {
      default:"#fafafa"
    }
  },
  overrides: {
    MuiAppBar: {
      root: {
        transform: 'translateZ(0)'
      }
    }
  },
  // No more ripple, on the whole application!
  props: {
    MuiIconButton:{
      disableRipple: true
    },
    MuiButtonBase: {
      disableRipple: true, 
    }
  }
});

const useStyles = makeStyles({
  appMain: {
    width: '100%'
  }
});



const App = () => {
  const classes = useStyles();

  //CLIENT STATE
  const [token, setToken] = useState(false);
  const [userId, setUserId] = useState();
  const [tokenExpirationDate, setTokenExpirationDate] = useState();
  const [userName, setUserName] = useState();
  const [documents, setDocuments] = useState();
 
  const [role, setRole] = useState();
  
  
  const login = useCallback((uid, username, token, role, documents, expirationDate) => {
    setToken(token)
    setUserId(uid);
    setUserName(username);
    setDocuments(documents)
    setRole(role)
    const tokenExpirationDate = expirationDate || new Date(new Date().getTime() + 1000 * 60 * 60);
    setTokenExpirationDate(tokenExpirationDate);
    localStorage.setItem(
      'userData', 
      JSON.stringify({ 
        userId: uid, 
        username: username, 
        token: token, 
        documents: documents,
        role: role, 
        expiration: tokenExpirationDate.toISOString() 
      })
    );
  }, []);

  const logout = useCallback(() => {
    setToken(null)
    setTokenExpirationDate(null);
    setUserId(null);
    setUserName(null);
    setRole(null);
    setDocuments([null]);
    localStorage.removeItem('userData');
  }, []);


  //client token and storedata management
  useEffect(() => {
      if (token && tokenExpirationDate) {
        const remainingTime = tokenExpirationDate.getTime() - new Date().getTime();
        logoutTimer = setTimeout(logout, remainingTime);
      }
  }, [token, logout, tokenExpirationDate])

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem('userData'));
    if (storedData && storedData.token && new Date(storedData.expiration) > new Date()) {
       login(storedData.userId, storedData.username, storedData.token, storedData.role, storedData.documents, new Date(storedData.expiration));
      // // login(storedData.userId, storedData.username, storedData.token, storedData.documents, new Date(storedData.expiration));
    } else {
      clearTimeout(logoutTimer);
    }
  }, [login]);
  
  let routes;

      if ( token && documents === 1 || documents > 1) {
        routes = (
          <>
          <MainNavigation/>
          <Switch>
                <Route path="/sommaire" exact>
                    <ClientMenu/>
                </Route>
                <Route path="/:clid/profil" exact>
                    <Profile/>
                </Route>
                <Route path="/:clid/documents" exact>
                    <Documents/>
                </Route>
                <Route path="/:clid/uploadDocuments" exact>
                    <DemandRequestVerification/>
                </Route>
                <Route path="/:clid/modeDemand" exact>
                    <UploadDocument/>
                </Route>
                <Route path="/:clid/contrat" exact>
                   <Contract/>
                </Route>
                <Route path="/:clid/releve" exact>
                   <ReleveClient/>
                </Route>
                <Route path="/:clid/releve" exact>
                    {/* ToDo */}
                </Route> 
          </Switch>
          <Redirect to="/sommaire" />
          </>
        );
    } else if (token && documents === 0) {
      routes = (
        <>
        {/* <MainNavigation/> */}
        <MainNavigationNoDocuemnt 
          hasDocument={documents}
        />
        <Switch>
              <Route path={`/${userId}/uploadDocuments`} exact>
                  <UploadDocument/>
              </Route>
              <Route path="/:clid/modeDemand" exact>
                    <DemandRequestVerification/>
                </Route>
              <Route path="/sommaire" exact>
                    <ClientMenu/>
                </Route>
                <Route path="/:clid/profil" exact>
                    <Profile/>
                </Route>
                <Route path="/:clid/documents" exact>
                    <Documents/>
                </Route>
                <Route path="/:clid/uploadDocuments" exact>
                    <UploadDocument/>
                </Route>
                {/* <Route path="/:clid/contrat" exact>
                    <Auth/>
                </Route> */}
                {/* <Route path="/:clid/releve" exact>
                    
                </Route> */}
              {/* <Redirect to={`/${userId}/uploadDocuments`} /> */}
              <Redirect to={`/${userId}/modeDemand`} />
        </Switch>
        </>
      );
    } 
    // else if (token && documents === 'admin'){
      else if (token && role === 'admin' && documents === null){
      routes = (
        <Switch>
          <Route path={`/adminDashboard/${userId}`} exact>
            <Admin/>
          </Route> 
          <Redirect to={`/adminDashboard/${userId}`} />
        </Switch>
      );
    }
     else {
      routes = (
        <>
        <MainNavigation/>
          <Switch>
              <Route path="/connexion" exact>
                <Auth/>
              </Route>
              <Route path="/modeDemand" exact>
                <DemandRequestVerification/>
              </Route>
              <Route path="/admin/authenticate" exact>
                <Authenticate/>
              </Route>
              <Route path="/inscription" exact>
                <ClientForm/>
              </Route>
              <Route path="/confirmationInscrition">
              <SignupConfirmation/>
              </Route>
              <Route path="/forgotPassword" exact>
                    <ForgotPassword/>
              </Route>
              <Route path="/reinitialisermotdepasse/:clientToken" exact>
                    <PasswordResetForm/>
              </Route>
            <Redirect to="/connexion" />
          </Switch>
        </>
      );
    }
   
  return (
    <ThemeProvider theme={theme}>
       <AuthContext.Provider 
        value={{
          isLoggedIn: !!token, 
          token: token, 
          userId: userId, 
          userName: userName, 
          // // role: role,
          documents: documents,
          login: login, 
          logout: logout,
        }}
       > 
      <Router>
        <div className={classes.appMain}>
              <Suspense
                fallback={
                  <div className="center">
                    <LoadingSpinner/>
                  </div>
                }
              >
                {routes}
              </Suspense>
          <CssBaseline/>
        </div>
      </Router>
      </AuthContext.Provider>

    </ThemeProvider >
  );
    
}

export default App;
